import React, { useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';

import LoginPage from '../login/LoginPage';
import ForgotPasswordPage from '../forgot-password/ForgotPasswordPage';
import ForgotPasswordThankYouPage from '../forgot-password-thank-you/ForgotPasswordThankYouPage';
import ResetPasswordPage from '../reset-password/ResetPasswordPage';
import ResetPasswordExpired from '../reset-password/Expired';
import ResetPasswordConfirm from '../reset-password/ResetPasswordConfirm';

import PublicHeader from './PublicHeader';
import Footer from './Footer';
import style from './PublicLayout.module.css';

const PublicLayout = () => {
  useEffect(() => {
    window.brandCode = 'HUB';
  }, []);

  return (
    <>
      <PublicHeader />
      <div className={style.main}>
        <section className={style.mainContent}>
          <Switch>
            <Route path="/login" exact component={LoginPage} />
            <Route
              path="/login/forgot-password"
              exact
              component={ForgotPasswordPage}
            />
            <Route
              path="/login/forgot-password/thank-you"
              exact
              component={ForgotPasswordThankYouPage}
            />
            <Route
              path="/login/changepassword/:token"
              exact
              component={ResetPasswordPage}
            />
            <Route
              path="/login/reset-password/expired"
              exact
              component={ResetPasswordExpired}
            />
            <Route
              path="/login/reset-password/confirm"
              exact
              component={ResetPasswordConfirm}
            />
          </Switch>
        </section>
        <Footer />
      </div>
    </>
  );
};

export default PublicLayout;
